import { render, staticRenderFns } from "./SurveyResults.vue?vue&type=template&id=1ccd3f3b&"
import script from "./SurveyResults.vue?vue&type=script&lang=js&"
export * from "./SurveyResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports